import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      {/* Upper Footer Section */}
      <div className="footer-upper pad-bottom-50">
        <div className="container">
          <div className="row">
            {/* Need Help Section */}
            <div className="col-lg-3 col-md-12 col-sm-12">
              <div className="footer-about">
                <div className="footer-about-in mar-bottom-30">
                  <h3 className="white">Need Amruta Travels Help?</h3>
                  <div className="footer-phone">
                    <div className="cont-icon"><i className="flaticon-call"></i></div>
                    <div className="cont-content mar-left-20">
                      <p className="mar-0">  <i className="flaticon-call text-white" style={{ marginRight: '8px' }}></i>Got Questions? Call us 24/7!</p>
                      <i class="fas fa-phone-alt text-white"></i> <a href="tel:+917353109555" class="bold mar-0">+91 7353109555</a><br />
                      <i class="fas fa-phone-alt text-white"></i> <a href="tel:+917353109555" class="bold mar-0">+91 7353109555</a><br />
                      <i class="fas fa-phone-alt text-white"></i> <a href="tel:+917353109555" class="bold mar-0">+91 7353109555</a>

                    </div>
                  </div>
                </div>
                <h3 className="white">Contact Info</h3>
                <p>
                  <a href="mailto:booking@bushireinpune.com">
                    <i class="fas fa-envelope"></i> booking@bushireinpune.com
                  </a>

                  <br />

                  <i class="fas fa-map-marker-alt"></i> Location: Amruta Travels : Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                </p>
       

                <ul className="social-links">
  <li>
    <a 
      href="https://www.facebook.com/profile.php?id=100008358793319&sfnsn=wiwspwa&mibextid=RUbZ1f" 
      aria-label="Follow us on Facebook"
    >
      <i className="fab fa-facebook" aria-hidden="true"></i>
    </a>
  </li>
  <li>
    <a 
      href="https://x.com/bushireinpune" 
      aria-label="Follow us on Twitter"
    >
      <i className="fab fa-twitter" aria-hidden="true"></i>
    </a>
  </li>
  <li>
    <a 
      href="https://www.instagram.com/bushireinpune/" 
      aria-label="Follow us on Instagram"
    >
      <i className="fab fa-instagram" aria-hidden="true"></i>
    </a>
  </li>
  <li>
    <a 
      href="https://www.linkedin.com/in/bushire-inpune-338001343/" 
      aria-label="Follow us on LinkedIn"
    >
      <i className="fab fa-linkedin" aria-hidden="true"></i>
    </a>
  </li>
</ul>

              </div>
            </div>

            {/* Company Links */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-links">
                <h3 className="white">Services</h3>

                <Link className="mx-md-2 d-block" to="/bus-hire-for-wedding-in-pune">
                  <i className="fa fa-car darkcolor"></i> Bus Hire For Wedding in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Buses-For-Corporate-Events">
                  <i className="fa fa-car darkcolor"></i> Buses For Corporate Events
                </Link>
                <Link className="mx-md-2 d-block" to="/25-Seater-Tempo-Traveller-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 25 Seater Tempo Traveller on Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/32-Seater-Bus-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 32 Seater Bus Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/35-Seater-Bus-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 35 Seater Bus on Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/45-Seater-Bus-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 45 Seater Bus on Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/50-Seater-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 50 Seater Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Shirdi-Bus-Hire">
                  <i className="fa fa-car darkcolor"></i> Pune to Shirdi Bus Hire
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Rentals-For-School-Trips-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Rentals For School Trips in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-booking-for-wedding-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus booking for wedding in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Booking-for-Marriage">
                  <i className="fa fa-car darkcolor"></i> Bus Booking for Marriage
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Service-for-Corporate-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Service for Corporate Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-on-Rent-For-Event-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus on Rent For Event in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Rental-for-Tour-Packages">
                  <i className="fa fa-car darkcolor"></i> Bus Rental for Tour Packages
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-for-Outstation">
                  <i className="fa fa-car darkcolor"></i> Bus Hire for Outstation
                </Link>
                <Link className="mx-md-2 d-block" to="/AC-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> AC Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-Bus-Hire-Rental-Service">
                  <i className="fa fa-car darkcolor"></i> Pune Bus Hire Rental Service
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Service-for-Picnic-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Service for Picnic in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Non-Ac-Bus-Rental-Service-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Non Ac Bus Rental Service in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Luxury-Bus-Rental-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Luxury Bus Rental in Pune
                </Link>
                <Link to="/bus-rental-in-baner">

<i className="fa fa-car"></i>

Bus Rental in Baner

</Link>
                <Link
    className="mx-md-2 d-block"
    to="/bus-rental-in-pune"
>
    <i className="fa fa-car darkcolor"></i>
    Bus Rental in Pune
</Link>
                <Link className="mx-md-2 d-block" to="/Luxury-Force-Urbania-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Luxury Force Urbania On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Force-Urbania-Luxury-Mini-Bus-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Force Urbania Luxury Mini Bus On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Bhimashankar-Jyotirlinga-Bus-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Jyotirlinga Bus Hire in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Alibaug-Bus-on-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Alibaug Bus on Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Ganpatipule-Beach-Bus-Rental-Service">
                  <i className="fa fa-car darkcolor"></i> Pune to Ganpatipule Beach Bus Rental Service
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-5-Jyotirlinga-Darshan-Bus-Hire">
                  <i className="fa fa-car darkcolor"></i> Pune to 5 Jyotirlinga Darshan Bus Hire
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Kolhapur-Bus-on-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Kolhapur Bus on Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Darshan-Bus-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Mumbai Darshan Bus On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-On-Rent-in-Pimpri-Chinchwad">
                  <i className="fa fa-car darkcolor"></i> Bus On Rent in Pimpri Chinchwad
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-for-School-Trips-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Hire for School Trips in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Nashik-Bus-on-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Nashik Bus on Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Bus-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Bus On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Pandharpur-Bus-Hire">
                  <i className="fa fa-car darkcolor"></i> Pune to Pandharpur Bus Hire
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Aurangabad-Bus-Hire-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Aurangabad Bus Hire On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-Local-Bus-on-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune Local Bus on Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-Near-me-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Hire Near me Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/32-35-40-45-50-Seater-Bus-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 32,35,40,45,50 Seater Bus on Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Lonavala-Bus-Hire">
                  <i className="fa fa-car darkcolor"></i> Pune to Lonavala Bus Hire
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune Sade Teen Shakti Peeth Bus on Rent
                </Link>



                  <Link className="mx-md-2 d-block" to="/Pune-to-Konkan-Darshan-Bus-Hire">
                  <i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Bus Hire
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Goa-Bus-Hire">
                  <i className="fa fa-car darkcolor"></i> Pune to Goa Bus Hire
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-in-Pimpri-Chinchwad">
                  <i className="fa fa-car darkcolor"></i> Bus Hire in Pimpri Chinchwad
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-on-Rent-in-Hadapsar">
                  <i className="fa fa-car darkcolor"></i> Bus on Rent in Hadapsar
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-on-Rent-in-Kharadi-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus on Rent in Kharadi Pune
                </Link>



                  <Link className="mx-md-2 d-block" to="/Bus-on-Rent-in-Hinjewadi">
                  <i className="fa fa-car darkcolor"></i> Bus on Rent in Hinjewadi
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-for-Picnic-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Hire for Picnic in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Corporate-Travels-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Corporate Travels in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/12-Jyotirlinga-Darshan-Tour-Package-from-Pune">
                  <i className="fa fa-car darkcolor"></i> 12 Jyotirlinga Darshan Tour Package from Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Rajasthan-Darshan-Bus-Package">
                  <i className="fa fa-car darkcolor"></i> Pune to Rajasthan Darshan Bus Package
                </Link>

                  
                <Link className="mx-md-2 d-block" to="/Tourist-Bus-Rental-Services">
                  <i className="fa fa-car darkcolor"></i> Tourist Bus Rental Services
                </Link>
               
              </div>
            </div>

            {/* Services Links */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-links">
                <h3 className="white">Services</h3>

               <Link className="mx-md-2 d-block" to="/Monthly-Bus-Hire-Service-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Monthly Bus Hire Service in Pune
                </Link>
            
                <Link className="mx-md-2 d-block" to="/Pune-to-Matheran-Bus-Travel">
                  <i className="fa fa-car darkcolor"></i> Pune to Matheran Bus Travel
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-for-Pune-to-Lonavala">
                  <i className="fa fa-car darkcolor"></i> Bus hire for Pune to Lonavala
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-on-Rent-for-Pune-to-Ashtavinayak-Darshan">
                  <i className="fa fa-car darkcolor"></i> Bus on Rent for Pune to Ashtavinayak Darshan
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-for-Pune-to-Maharashtra-Darshan">
                  <i className="fa fa-car darkcolor"></i> Bus hire for Pune to Maharashtra Darshan
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-for-Kedarnath-Trip">
                  <i className="fa fa-car darkcolor"></i> Bus Hire For Kedarnath Trip
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Hyderabad-Bus-on-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Hyderabad Bus On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-Service-for-Pune-Airport">
                  <i className="fa fa-car darkcolor"></i> Bus Hire Service for Pune Airport
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Mahabaleshwar-Bus-on-Rent-Service">
                  <i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Bus On Rent Service
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Bhimashankar-Bus-on-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Bus on Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-for-Pune-to-Ashtavinayak">
                  <i className="fa fa-car darkcolor"></i> Bus hire for Pune to Ashtavinayak
                </Link>
                <Link className="mx-md-2 d-block" to="/Volvo-Bus-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Volvo Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/25-Seater-Bus-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 25 Seater Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Rent-a-Bus-For-a-Trip">
                  <i className="fa fa-car darkcolor"></i> Rent a Bus For a Trip
                </Link>
                <Link className="mx-md-2 d-block" to="/Bharatbenz-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bharatbenz Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-Bus-hire-Online-Booking-Service">
                  <i className="fa fa-car darkcolor"></i> Pune Bus hire Online Booking Service
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Hire in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Bus-Hire-in-Baner-Pune">
                  <i className="fa fa-car darkcolor"></i> Bus Hire in Baner Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Urbania On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Pune-for-Corporate">
                  <i className="fa fa-car darkcolor"></i> Urbania On Rent in Pune for Corporate
                </Link>
                <Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Pimpri-Chinchwad">
                  <i className="fa fa-car darkcolor"></i> Urbania On Rent in Pimpri Chinchwad
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Shirdi-Urbania-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Shirdi Urbania On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Urbania-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Mumbai Urbania On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Goa-Urbania-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Goa Urbania On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Mini-Bus-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Mini Bus On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/17-Seater-Bus-on-Rent-Pune">
                  <i className="fa fa-car darkcolor"></i> 17 Seater Bus on Rent Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Nearby-Places-Picnic-Spot-Bus-On-Rent">
                  <i className="fa fa-car darkcolor"></i> Pune to Nearby Places Picnic Spot Bus On Rent
                </Link>
                <Link className="mx-md-2 d-block" to="/Travel-Agents-in-Pune-for-Full-Bus-Hire">
                  <i className="fa fa-car darkcolor"></i> Travel Agents in Pune for Full Bus Hire
                </Link>




                   <Link className="mx-md-2 d-block" to="/Tempo-Traveller-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Tempo Traveller Hire in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Explore-All-India-Bus-Hire-Services-From-Pune">
                  <i className="fa fa-car darkcolor"></i> Explore All India Bus Hire Services From Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/45-Seater-Ac-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 45 Seater Ac Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/35-Seater-Ac-Bus-On-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 35 Seater Ac Bus On in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/53-Seater-Ac-Bharat-Benz-on-Rent-Pune">
                  <i className="fa fa-car darkcolor"></i> 53 Seater Ac Bharat Benz on Rent Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/45-Seater-Ac-Bharat-Benz-On-Rent-Pune">
                  <i className="fa fa-car darkcolor"></i> 45 Seater Ac Bharat Benz On Rent Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/35-Seater-Ac-Bharat-Benz-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 35 Seater Ac Bharat Benz Hire in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/40-Seater-Ac-Bharat-Benz-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 40 Seater Ac Bharat Benz on Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/25-Seater-Tata-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 25 Seater Tata Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Ac-45-Seater-Bharat-Benz-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Ac 45 Seater Bharat Benz Hire in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Ashok-Leyland-Ac-45-Seater-Bus-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Ashok Leyland Ac 45 Seater Bus Hire in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Luxury-Ac-32-Seater-Tata-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Luxury Ac 32 Seater Tata Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Ac-24-Seater-Tata-Bus-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Ac 24 Seater Tata Bus Hire in Pune
                </Link>
                


                   
                <Link className="mx-md-2 d-block" to="/Luxury-Ac-36-Seater-Bharat-Benz-Bus-on-Rent-Pune">
                  <i className="fa fa-car darkcolor"></i> Luxury Ac 36 Seater Bharat Benz Bus on Rent Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/53-Seater-Volvo-Bus-Hire-Pune">
                  <i className="fa fa-car darkcolor"></i> 53 Seater Volvo Bus Hire Pune
                </Link>
              </div>
            </div>




            {/* Services Links */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-links">
                <h3 className="white">Services</h3>


          
                <Link className="mx-md-2 d-block" to="/53-Seater-Bharat-Benz-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 53 Seater Bharat Benz Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/40-Seater-Bharat-Benz-Bus-Hire-Pune">
                  <i className="fa fa-car darkcolor"></i> 40 Seater Bharat Benz Bus Hire Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/50-Seater-Bus-On-Rent-in-Pimpri-Chinchwad">
                  <i className="fa fa-car darkcolor"></i> 50 Seater Bus On Rent in Pimpri Chinchwad
                </Link>
                <Link className="mx-md-2 d-block" to="/12-Jyotirlinga-Darshan-Bus-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> 12 Jyotirlinga Darshan Bus Hire in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Ashtavinayak-Darshan-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Ashtavinayak Darshan Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Corporate-Bus-Services-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Corporate Bus Services in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Corporate-Events-Bus-On-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Corporate Events Bus On Rent in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Top-Rated-Bus-Hire-in-Pune-Amruta-Travels">
                  <i className="fa fa-car darkcolor"></i> Top Rated Bus Hire in Pune Amruta Travels
                </Link>
                <Link className="mx-md-2 d-block" to="/Ac-45-Seater-Bharat-Benz-Bus-Hire-Shirdi">
                  <i className="fa fa-car darkcolor"></i> Ac 45 Seater Bharat Benz Bus Hire Shirdi
                </Link>
                <Link className="mx-md-2 d-block" to="/Ac-45-Seater-Bharat-Benz-Bus-Hire-Aurangabad-Sambhaji-Nagar">
                  <i className="fa fa-car darkcolor"></i> Ac 45 Seater Bharat Benz Bus Hire Aurangabad ( Sambhaji Nagar )
                </Link>
                <Link className="mx-md-2 d-block" to="/Ac-Luxury-45-Seater-Bharat-Benz-Bus-Hire-Ahmednagar">
                  <i className="fa fa-car darkcolor"></i> Ac Luxury 45 Seater Bharat Benz Bus Hire Ahmednagar
                </Link>
                <Link className="mx-md-2 d-block" to="/Ac-Luxury-45-Seater-Bus-Hire-Nashik">
                  <i className="fa fa-car darkcolor"></i> Ac Luxury 45 Seater Bus Hire Nashik
                </Link>

                <Link className="mx-md-2 d-block" to="/Outstation-Bus-Hire-Service-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Outstation Bus Hire Service in Pune
                </Link>
                <Link className="mx-md-2 d-block" to="/Pune-to-Pan-India-Bus-Service-Amruta-Travels">
                  <i className="fa fa-car darkcolor"></i> Pune to Pan India Bus Service Amruta Travels
                </Link>

                <Link className="mx-md-2 d-block" to="/Volvo-Sleeper-Bus-on-Rent-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Volvo Sleeper Bus on Rent in Pune
                </Link>

                <Link className="mx-md-2 d-block" to="/Best-Luxury-Bus-Hire-in-Pune">
                  <i className="fa fa-car darkcolor"></i> Best Luxury Bus Hire in Pune
                </Link>




<Link className="mx-md-2 d-block" to="/Force-Urbania-17-Seater-On-Rent-in-Pune">
  <i className="fa fa-car darkcolor"></i> Force Urbania 17 Seater On Rent in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-Hire-in-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania Hire in Pune
</Link>

{/* <Link className="mx-md-2 d-block" to="/Urbania-Hire-in-Urbania-On-Rent-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania Hire in Urbania On Rent Pune
</Link> */}

<Link className="mx-md-2 d-block" to="/Urbania-Hire-for-Corporate-Events-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania Hire for Corporate Events Pune
</Link>

<Link className="mx-md-2 d-block" to="/Book-Force-Urbania-on-Rent-in-Pune">
  <i className="fa fa-car darkcolor"></i> Book Force Urbania on Rent in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Force-Urbania-On-Rent-Pune">
  <i className="fa fa-car darkcolor"></i> Force Urbania On Rent Pune
</Link>

<Link className="mx-md-2 d-block" to="/13-Seater-Urbania-On-Rent-in-Pune">
  <i className="fa fa-car darkcolor"></i> 13 Seater Urbania On Rent in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Outstation-Urbania-On-Rent-Pune">
  <i className="fa fa-car darkcolor"></i> Outstation Urbania On Rent Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-on-rent-in-Pune-for-family-Trip">
  <i className="fa fa-car darkcolor"></i> Urbania on rent in Pune for family Trip
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-Rental-Services-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania Rental Services Pune
</Link>

<Link className="mx-md-2 d-block" to="/Force-Urbania-Rent-Per-km-in-Pune">
  <i className="fa fa-car darkcolor"></i> Force Urbania Rent Per km in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Cheap-Urbania-rental-in-Pune">
  <i className="fa fa-car darkcolor"></i> Cheap Urbania rental in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-Bus-Rental-Service-in-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania Bus Rental Service in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Pune-Airport-Urbania-on-Rent">
  <i className="fa fa-car darkcolor"></i> Pune Airport Urbania on Rent
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Kharadi">
  <i className="fa fa-car darkcolor"></i> Urbania On Rent in Kharadi
</Link>

<Link className="mx-md-2 d-block" to="/Force-Urbania-Rental-in-Wagholi-Pune">
  <i className="fa fa-car darkcolor"></i> Force Urbania Rental in Wagholi Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-on-rent-in-Viman-Nagar-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania on rent in Viman Nagar Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-hire-in-Hadapsar-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania hire in Hadapsar Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Kothrud-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania On Rent in Kothrud Pune
</Link>

<Link className="mx-md-2 d-block" to="/Force-Urbania-rental-in-Aundh-Pune">
  <i className="fa fa-car darkcolor"></i> Force Urbania rental in Aundh Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-on-Rent-in-Baner-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania on Rent in Baner Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-hire-in-Pimple-Saudagar-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania hire in Pimple Saudagar Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-hire-service-in-Bhosari-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania hire service in Bhosari Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-on-rent-in-Katraj-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania on rent in Katraj Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-Hire-for-Pune-Darshan">
  <i className="fa fa-car darkcolor"></i> Urbania Hire for Pune Darshan
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-Rental-in-Karve-Nagar-Kothrud">
  <i className="fa fa-car darkcolor"></i> Urbania Rental in Karve Nagar Kothrud
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-Hire-for-Corporate-in-Pune">
  <i className="fa fa-car darkcolor"></i> Urbania Hire for Corporate in Pune
</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Ashtavinayak-darshan-Urbania-Hire">
  <i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak darshan Urbania Hire
</Link>

<Link className="mx-md-2 d-block" to="/Amruta-Travels-Pune">
  <i className="fa fa-car darkcolor"></i> Amruta Travels Pune
</Link>

<Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Pune-Contact-Number">
  <i className="fa fa-car darkcolor"></i> Urbania On Rent in Pune Contact Number
</Link>


              </div>
            </div>


          </div>
        </div>
      </div>

      {/* Footer Copyright Section */}
      <div className="footer-copyright">
        <div className="container">
          <div className="copyright-text pull-left text-center">
            {/* <p className="mar-0">2020 Nepayatri. All rights reserved.</p> */}
            <p className="copyright-text align-self-center text-center">
              All Rights Reserved &copy;  <span className="darkkcolorrr">Amruta Travels</span> <span id="date">{new Date().getFullYear()}</span>{' '}
              <span> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkkcolorrr">&nbsp;Urva Hosting</span>
              </a>
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
